import Vuex from 'vuex'
import Vue from 'vue'
import global from './modules/global'
import agency from './modules/agency'
import summerCamps from './modules/summerCamps'
import languageSchools from './modules/languageSchools'
import university from './modules/university'
import filters from './modules/filters'
import profile from './modules/profile'
import applications from './modules/applications'
import favorites from "./modules/favorites";
import comparison from "./modules/comparison";
import createStudent from "./modules/createStudent";
import catalogs from "./modules/catalogs";
import auth from './modules/auth'
import chat from './modules/chat'
import Visual from 'vue-visual'
Vue.component('visual', Visual)
import 'vue-visual/index.css'
import Multiselect from 'vue-multiselect'



Vue.use(Vuex)
Vue.component('multiselect', Multiselect)


export const store =  new Vuex.Store({
	modules:{
		global,
		languageSchools,
		university,
		filters,
		profile,
		applications,
		favorites,
		comparison,
		createStudent,
		catalogs,
		auth,
		chat,
		agency,
		summerCamps
	}
})
